import { render, staticRenderFns } from "./BlogPostInfo.vue?vue&type=template&id=883047fe&scoped=true&"
import script from "./BlogPostInfo.vue?vue&type=script&lang=js&"
export * from "./BlogPostInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883047fe",
  null
  
)

export default component.exports